import { HTMLSelect, Label } from '@blueprintjs/core';
import { THEME_NAMES, useTheme } from 'es/app/theme';
import { setThemeName } from 'es/app/theme/actions';
import { ThemeName } from 'es/app/theme/theme.types';
import styles from './ThemeSwitch.module.css';
import { useI18n } from 'es/core/hooks/useI18n';

type ThemeSwitchProps = {
    onSelect: (themeName: ThemeName) => void;
};

const INPUT_ID = 'theme-switch';

export const ThemeSwitch = ({ onSelect }: ThemeSwitchProps) => {
    const { l10n } = useI18n('app/components/layout', 'theme');
    const { themeName, dispatch } = useTheme();
    return (
        <>
            <Label htmlFor={INPUT_ID} className={styles.themeSwitchLabel}>
                {l10n('title')}
            </Label>
            <HTMLSelect
                id={INPUT_ID}
                value={themeName}
                onChange={e => {
                    const themeName = THEME_NAMES.find(v => v === e.target.value);
                    if (!themeName) return;
                    dispatch(setThemeName(themeName));
                    onSelect(themeName);
                }}
            >
                {THEME_NAMES.map(themeName => (
                    <option value={themeName} key={themeName}>
                        {themeName === 'dark' && `${l10n('dark')} (${l10n('beta')})`}
                        {themeName === 'light' && l10n('light')}
                    </option>
                ))}
            </HTMLSelect>
        </>
    );
};
